import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { Edit, RotateCcw } from "feather-icons-react/build/IconComponents";
import EditKpiMetricDetails from "./Edit";
import AddKpiMetricDetails from "./Add";
import { Spin } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ROLL_CALL_API_BASE_URL } from "../../../RollCall/RollCallConfig/RollCallConfig";

const KpiMetricDetails = () => {
  const [editObj, setEditObj] = useState(null);
  const [tokenData, setTokenData] = useState(null);
  const [metricDetails, setMetricDetails] = useState([]);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);

  useEffect(() => {
    const stored = sessionStorage.getItem("rollcall-permissions");
    if (!stored) return;

    const map = JSON.parse(stored);
    const path = location.pathname.slice(1);
    const perms = map[path];
    if (!perms) {
      navigate("/rollcall/dashboard");
      return;
    }
    if (perms) {
      setPerm({
        Read: perms.canRead,
        Write: perms.canWrite,
        Delete: perms.canDelete,
        Export: perms.canExport,
      });
    }
  }, []);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const fetchMetricDetails = async () => {
    if (tokenData && superIdData) {
      setLoading(true);

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/kpi/getKpiMetricDetails?SuperId=${superIdData}&MetricId=0&Status=NULL`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${tokenData}`,
            },
          },
        );

        const data = await response.json();

        console.log(data, "metric details response");

        if (data?.status) {
          setMetricDetails(data?.ResultData || []);
        } else {
          console.error(
            "Failed to fetch metric details:",
            data?.message || response.statusText,
          );
          setMetricDetails([]);
        }
      } catch (error) {
        console.error("Error fetching metric details:", error.message);
        setMetricDetails([]);
      } finally {
        setLoading(false);
      }
    }
  };
  useEffect(() => {
    if (tokenData && superIdData) {
      fetchMetricDetails();
    }
  }, [tokenData, superIdData]);

  const columns = [
    {
      title: "Metric Name",
      dataIndex: "MetricName",
      sorter: (a, b) => (a.MetricName || "").localeCompare(b.MetricName || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Title",
      dataIndex: "Title",
      sorter: (a, b) => (a.Title || "").localeCompare(b.Title || ""),
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a, b) =>
        (a.Description || "").length - (b.Description || "").length,
      render: (record) =>
        record
          ? record.length > 15
            ? `${record.substring(0, 15)}...`
            : record
          : "N/A",
    },
    {
      title: "Input Type",
      key: "InputType",
      align: "center",
      render: (_, record) => {
        const types = [];

        if (record.HasText) {
          types.push({ label: "Text", color: "blue" });
        }
        if (record.HasFlag) {
          types.push({ label: "Checkbox", color: "green" });
        }
        if (record.HasValue) {
          types.push({ label: "Number", color: "purple" });
        }

        return (
          <div className="d-flex justify-content-center gap-2 flex-wrap">
            {types.map((type, index) => (
              <span
                key={index}
                className={`badge bg-${type.color}`}
                style={{ fontSize: "12px", padding: "6px 10px" }}
              >
                {type.label}
              </span>
            ))}
          </div>
        );
      },
    },

    // {
    //   title: "Status",
    //   dataIndex: "IsActive",
    //   key: "IsActive",
    //   sorter: (a, b) =>
    //     (a.IsActive === "active" ? 1 : 0) - (b.IsActive === "active" ? 1 : 0),
    //   render: (status) => (
    //     <Switch
    //       checked={status === true}
    //       style={{
    //         transform: "scale(0.8)",
    //         transformOrigin: "left center",
    //       }}
    //     />
    //   ),
    // },
  ];

  if (perm?.Write) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (_, record) => (
        <div className="action-table-data d-flex justify-content-center">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              onClick={() => {
                handelShowEdit(record);
              }}
            >
              <Edit className="feather-edit text-info" />
            </Link>
          </div>
        </div>
      ),
    });
  }

  const handelShowEdit = (record) => {
    setShowEdit(true);
    setEditObj(record);
  };

  const handleReload = () => {
    window.location.reload();
  };

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Metric Details
                    </h4>
                  </ol>
                </nav>
                <h6>Metrics Details At A Glance</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            {perm?.Write && (
              <div className="page-btn mb-3">
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  // data-bs-toggle="offcanvas"
                  // data-bs-target="#offcanvasRightAddKpiMetricDetails"
                  // aria-controls="offcanvasRightAddKpiMetricDetails"
                  onClick={() => setShowAdd(true)}
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            )}
          </div>
          {perm.Read ? (
            <div className="card table-list-card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <div className="search-set">
                  <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                    <div className="col-6 mb-2">
                      <label className="form-label"></label>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <div className="card-body">
                <div className="table-responsive">
                  {loading ? (
                    <div className="text-center my-4">
                      <Spin size="large"></Spin>
                      <p>Loading data...</p>
                    </div>
                  ) : (
                    <Table
                      columns={columns}
                      dataSource={metricDetails}
                      pgno={true}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="card">
              <div className="card-body d-flex justify-content-center">
                <h1>You dont have access to this page</h1>
              </div>
            </div>
          )}
        </div>
        <CommonFooter />
      </div>

      <AddKpiMetricDetails
        isOpen={showAdd}
        fetchMetricDetails={fetchMetricDetails}
        onClose={() => setShowAdd(false)}
      />

      <EditKpiMetricDetails
        editObj={editObj}
        isOpen={showEdit}
        fetchMetricDetails={fetchMetricDetails}
        onClose={() => setShowEdit(false)}
      />
    </div>
  );
};

export default KpiMetricDetails;
